function matrixFunction(a) {
  return function (b) {
    var c = b[0]
    , d = b[1]
    , e = b[2];
    return [c * a.R[0] / 100 + d * a.R[1] / 100 + e * a.R[2] / 100, c * a.G[0] / 100 + d * a.G[1] / 100 + e * a.G[2] / 100, c * a.B[0] / 100 + d * a.B[1] / 100 + e * a.B[2] / 100]
  }
}
function clearImageCache() {
  imageCache = {},
    urlCache = {}
}
function getFilteredImage(a, b, c) {
  if (b in imageCache)
    c(imageCache[b], urlCache[b]);
  else if ("hcirnNormal" === b || "simplNormal" === b)
    imageCache[b] = a,
      urlCache[b] = "#",
      c(a, "#");
  else {
    createFilteredImage(a, b, function (a, d) {
      imageCache[b] = a,
        urlCache[b] = d,
        c(a, d)
    })
  }
}
function createFilteredImage(a, b, c) {
  var d = getFilterFunction(b)
  , e = document.createElement("canvas")
  , f = a.naturalWidth
  , g = a.naturalHeight;
  e.setAttribute("width", f),
    e.setAttribute("height", g);
  var h = e.getContext("2d");
  h.drawImage(a, 0, 0);
  var i = h.getImageData(0, 0, f, g)
  , j = Math.max(Math.floor(i.data.length / 5), 1)
  , k = 0;
  setTimeout(function a() {
    for (var b = Math.min(k + j, i.data.length); k < b; k += 4) {
      var f = [i.data[k], i.data[k + 1], i.data[k + 2]];
      filteredRGB = d(f),
        i.data[k] = filteredRGB[0],
        i.data[k + 1] = filteredRGB[1],
        i.data[k + 2] = filteredRGB[2]
    }
    if (NProgress.set(.2 + .8 * (k / i.data.length)),
        k < i.data.length)
      setTimeout(a, 0);
    else {
      h.putImageData(i, 0, 0);
      var g = e.toDataURL();
      var l = new Image;
      l.onload = function () {
        c(this, g)
      }
      ,
        l.src = g
    }
  }, 0)
}
function getFilterFunction(a) {
  var b;
  if ("hcirn" === a.substring(0, 5))
    b = fBlind;
  else {
    if ("simpl" !== a.substring(0, 5))
      throw "Invalid Filter Type!";
    b = colorMatrixFilterFunctions
  }
  if (a = a.substring(5),
      a in b)
    return b[a];
  throw "Library does not support Filter Type: " + a
}
function filterOrImageChanged() {
  var a = document.querySelector('input[name = "colorblindType"]:checked').value
  , b = "hcirn" + a;
  currentImage ? (document.getElementById("image-container").style.background = "none",
                  document.getElementById("lens-no").disabled = !1,
                  document.getElementById("lens-normal").disabled = !1,
                  document.getElementById("lens-inverse").disabled = !1,
                  document.getElementById("imageLink").style.display = "Normal" === a ? "none" : "inline-block",
                  document.getElementById("newtab").style.display = "Normal" === a ? "none" : "inline-block",
                  loadingIndicator.style.display = "inline",
                  NProgress.set(.2),
                  setTimeout(function () {
    getFilteredImage(currentImage, b, function (a, b) {
      document.getElementById("imageLink").href = b,
        panZoomImage.displayImage(a),
        NProgress.done(),
        loadingIndicator.style.display = "none"
    })
  }, 0)) : document.getElementById("canvasDiv").style.backgroundImage = ""
}
function lensChanged() {
  var a = document.querySelector('input[name = "lens"]:checked').value;
  if ("No" === a)
    panZoomImage.lens = 0;
  else if ("Normal" === a)
    panZoomImage.lens = 1;
  else {
    if ("Inverse" !== a)
      throw "Illegal Lens Type";
    panZoomImage.lens = 2
  }
  panZoomImage.redraw()
}
function readFile(a) {
  if (FileReader && a && a.length) {
    if (1 !== a.length)
      return void alert("Can only show one file at a time");
    if (!a[0].type.match("image.*"))
      return void alert("Was not an image file. :(");

    var ua = navigator.userAgent.toLowerCase(); 
    if (ua.indexOf('safari') != -1) { 
      if (ua.indexOf('chrome') > -1) {
        NProgress.set(0);
        var b = new FileReader;
        b.onload = function () {
          var a = new Image;
          document.getElementById("original-image").src = b.result;
          document.getElementById("original-image").style.display = "block";
          setCanvasSize();
          a.onload = function () {
            currentImage = this,
              panZoomImage.setHiddenLensImage(currentImage),
              clearImageCache(),
              filterOrImageChanged(),
              panZoomImage.initialZoom(currentImage),
              setCanvasSize(this.width, this.height);
          }
          ,
            a.src = b.result
        },
          b.readAsDataURL(a[0]);
      } else {
        getOrientation(a[0], function (orientation) {
          image_orientation = orientation;
          NProgress.set(0);
          var b = new FileReader;
          b.onload = function () {
            resetOrientation(b.result, orientation, function(base64){
              var a = new Image;
              document.getElementById("original-image").src = base64;
              document.getElementById("original-image").style.display = "block";
              setCanvasSize();
              a.onload = function () {
                currentImage = this,
                  panZoomImage.setHiddenLensImage(currentImage),
                  clearImageCache(),
                  filterOrImageChanged(),
                  panZoomImage.initialZoom(currentImage),
                  setCanvasSize(this.width, this.height);
              }
              ,
                a.src = base64
            })



          }
          ,
            b.readAsDataURL(a[0]);
        });
      }
    } else {
      getOrientation(a[0], function (orientation) {
        image_orientation = orientation;
        NProgress.set(0);
        var b = new FileReader;
        b.onload = function () {
          resetOrientation(b.result, orientation, function(base64){
            var a = new Image;
            document.getElementById("original-image").src = base64;
            document.getElementById("original-image").style.display = "block";
            setCanvasSize();
            a.onload = function () {
              currentImage = this,
                panZoomImage.setHiddenLensImage(currentImage),
                clearImageCache(),
                filterOrImageChanged(),
                panZoomImage.initialZoom(currentImage),
                setCanvasSize(this.width, this.height);
            }
            ,
              a.src = base64
          })



        }
        ,
          b.readAsDataURL(a[0]);
      });
    }

  } else {
    alert("Your Browser does not support the required Features.")
  }
}

function setImage(url) {
  NProgress.set(0);
  (async function () {
    let blob = await fetch(url).then(r => r.blob());
    let dataUrl = await new Promise(resolve => {
      let reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
    var a = new Image;
    document.getElementById("original-image").src = dataUrl;
    document.getElementById("original-image").style.display = "block";
    setCanvasSize();
    a.onload = function () {
      this.crossOrigin = "anonymous",
        currentImage = this,
        panZoomImage.setHiddenLensImage(currentImage),
        clearImageCache(),
        filterOrImageChanged(),
        panZoomImage.initialZoom(currentImage),
        setCanvasSize(this.width, this.height);
    }
    ,
      a.src = dataUrl
  })();
}

function blindMK(a, b) {
  var d = .312713
  , e = .329016
  , f = .358271
  , g = a[2]
  , h = a[1]
  , i = a[0]
  , j = powGammaLookup[i]
  , k = powGammaLookup[h]
  , l = powGammaLookup[g]
  , m = .430574 * j + .34155 * k + .178325 * l
  , n = .222015 * j + .706655 * k + .07133 * l
  , o = .020183 * j + .129553 * k + .93918 * l
  , p = m + n + o
  , q = 0
  , r = 0;
  0 != p && (q = m / p,
             r = n / p);
  var u, s = d * n / e, t = f * n / e, v = 0;
  u = q < rBlind[b].cpu ? (rBlind[b].cpv - r) / (rBlind[b].cpu - q) : (r - rBlind[b].cpv) / (q - rBlind[b].cpu);
  var w = r - q * u
  , x = (rBlind[b].ayi - w) / (u - rBlind[b].am)
  , y = u * x + w
  , z = x * n / y
  , A = n
  , B = (1 - (x + y)) * n / y
  , C = 3.063218 * z - 1.393325 * A - .475802 * B
  , D = -.969243 * z + 1.875966 * A + .041555 * B
  , E = .067871 * z - .228834 * A + 1.069251 * B
  , F = s - z
  , G = t - B;
  dr = 3.063218 * F - 1.393325 * v - .475802 * G,
    dg = -.969243 * F + 1.875966 * v + .041555 * G,
    db = .067871 * F - .228834 * v + 1.069251 * G;
  var H = dr ? ((C < 0 ? 0 : 1) - C) / dr : 0
  , I = dg ? ((D < 0 ? 0 : 1) - D) / dg : 0
  , J = db ? ((E < 0 ? 0 : 1) - E) / db : 0
  , K = Math.max(H > 1 || H < 0 ? 0 : H, I > 1 || I < 0 ? 0 : I, J > 1 || J < 0 ? 0 : J);
  return C += K * dr,
    D += K * dg,
    E += K * db,
    [inversePow(C), inversePow(D), inversePow(E)]
}
function inversePow(a) {
  return 255 * (a <= 0 ? 0 : a >= 1 ? 1 : Math.pow(a, 1 / 2.2))
}
function anomylize(a, b) {
  var c = 1.75
  , d = 1 * c + 1;
  return [(c * b[0] + 1 * a[0]) / d, (c * b[1] + 1 * a[1]) / d, (c * b[2] + 1 * a[2]) / d]
}
function monochrome(a) {
  var b = Math.round(.299 * a[0] + .587 * a[1] + .114 * a[2]);
  return [b, b, b]
}
var ColorMatrixMatrixes = {
  Normal: {
    R: [100, 0, 0],
    G: [0, 100, 0],
    B: [0, 0, 100]
  },
  Protanopia: {
    R: [56.667, 43.333, 0],
    G: [55.833, 44.167, 0],
    B: [0, 24.167, 75.833]
  },
  Protanomaly: {
    R: [81.667, 18.333, 0],
    G: [33.333, 66.667, 0],
    B: [0, 12.5, 87.5]
  },
  Deuteranopia: {
    R: [62.5, 37.5, 0],
    G: [70, 30, 0],
    B: [0, 30, 70]
  },
  Deuteranomaly: {
    R: [80, 20, 0],
    G: [25.833, 74.167, 0],
    B: [0, 14.167, 85.833]
  },
  Tritanopia: {
    R: [95, 5, 0],
    G: [0, 43.333, 56.667],
    B: [0, 47.5, 52.5]
  },
  Tritanomaly: {
    R: [96.667, 3.333, 0],
    G: [0, 73.333, 26.667],
    B: [0, 18.333, 81.667]
  },
  Achromatopsia: {
    R: [29.9, 58.7, 11.4],
    G: [29.9, 58.7, 11.4],
    B: [29.9, 58.7, 11.4]
  },
  Achromatomaly: {
    R: [61.8, 32, 6.2],
    G: [16.3, 77.5, 6.2],
    B: [16.3, 32, 51.6]
  }
}
, colorMatrixFilterFunctions = {};
for (var t in ColorMatrixMatrixes)
  ColorMatrixMatrixes.hasOwnProperty(t) && (colorMatrixFilterFunctions[t] = matrixFunction(ColorMatrixMatrixes[t]));
var imageCache = {}
, urlCache = {}
, loadingIndicator = document.getElementById("loadingIndicator");
NProgress.configure({
  parent: "#progressBar"
}),
  function () {
  var b, a = document.querySelectorAll('input[name = "colorblindType"]');
  for (b = 0; b < a.length; b++)
    a[b].onclick = filterOrImageChanged;
}();
var fileInput = document.getElementById("fileInput"), currentImage;
fileInput.onchange = function (a) {
  var b = a.target || window.event.srcElement
  , c = b.files;
  readFile(c)
}
;
var canvasDiv = document.getElementById("canvasDiv");
canvasDiv.addEventListener("drop", function (a) {
  a.stopPropagation(),
    a.preventDefault(),
    readFile(a.dataTransfer.files)
}, !1),
  canvasDiv.addEventListener("dragover", function (a) {
  a.stopPropagation(),
    a.preventDefault(),
    a.dataTransfer.dropEffect = "copy"
}, !1),
  canvasDiv.addEventListener("dragleave", function (a) { }, !1),
  document.onpaste = function (a) {
  for (var b = (a.clipboardData || a.originalEvent.clipboardData).items, c = null, d = 0; d < b.length; d++)
    0 === b[d].type.indexOf("image") && (c = b[d].getAsFile());
  null !== c && readFile([c])
}
;
var rBlind = {
  protan: {
    cpu: .735,
    cpv: .265,
    am: 1.273463,
    ayi: -.073894
  },
  deutan: {
    cpu: 1.14,
    cpv: -.14,
    am: .968437,
    ayi: .003331
  },
  tritan: {
    cpu: .171,
    cpv: -.003,
    am: .062921,
    ayi: .292119
  }
}
, fBlind = {
  Normal: function (a) {
    return a
  },
  Protanopia: function (a) {
    return blindMK(a, "protan")
  },
  Protanomaly: function (a) {
    return anomylize(a, blindMK(a, "protan"))
  },
  Deuteranopia: function (a) {
    return blindMK(a, "deutan")
  },
  Deuteranomaly: function (a) {
    return anomylize(a, blindMK(a, "deutan"))
  },
  Tritanopia: function (a) {
    return blindMK(a, "tritan")
  },
  Tritanomaly: function (a) {
    return anomylize(a, blindMK(a, "tritan"))
  },
  Achromatopsia: function (a) {
    return monochrome(a)
  },
  Achromatomaly: function (a) {
    return anomylize(a, monochrome(a))
  }
};
powGammaLookup = Array(256),
  function () {
  var a;
  for (a = 0; a < 256; a++)
    powGammaLookup[a] = Math.pow(a / 255, 2.2)
    }(),
  panZoomImage = {
  canvas: document.getElementById("outCanvas"),
  lastX: 0,
  lastY: 0,
  translateX: 0,
  translateY: 0,
  scale: 1,
  dragged: !1,
  lens: 0
},
  panZoomImage.displayImage = function (b) {
  switch (image_orientation) {
    case 8:
      this.canvas.getContext("2d").rotate(90 * Math.PI / 180);
      break;
    case 3:
      this.canvas.getContext("2d").rotate(180 * Math.PI / 180);
      break;
    case 6:
      this.canvas.getContext("2d").rotate(-90 * Math.PI / 180);
      break;
  }
  this.ctx = this.canvas.getContext("2d"),
    this.currentImage = b,
    this.onresize(),
    this.redraw();
}
,
  panZoomImage.resetView = function () {
  this.currentImage && (this.translateX = 0,
                        this.translateY = 0,
                        this.scale = 1,
                        this.onresize(),
                        this.currentImage.width > this.currentImage.height ? this.scale = this.canvas.width / this.currentImage.width : (this.scale = this.canvas.height / this.currentImage.height,
                                                                                                                                         this.translateX = (this.canvas.width - this.scale * this.currentImage.width) / 2),
                        this.redraw())
}
,
  panZoomImage.initialZoom = function (b) {
  this.ctx = this.canvas.getContext("2d"),
    this.currentImage = b,
    this.resetView()
}
,
  panZoomImage.setHiddenLensImage = function (b) {
  this.hiddenLensImage = b,
    this.redraw()
}
,
  panZoomImage.onresize = function () {
  // this.canvas.style.width = "100%",
  // this.canvas.style.height = "100%",
  this.canvas.width = this.canvas.offsetWidth,
    this.canvas.height = this.canvas.offsetHeight,
    this.redraw()
}
,
  window.addEventListener("resize", function () {
  panZoomImage.onresize()
}, !1),
  window.addEventListener("load", function () {
  panZoomImage.onresize()
}, !1),
  panZoomImage.getFullImage = function () {
  return 0 === this.lens || 1 === this.lens ? this.currentImage : this.hiddenLensImage
}
,
  panZoomImage.getLensImage = function () {
  return 2 === this.lens ? this.currentImage : this.hiddenLensImage
}
,
  panZoomImage.clearImage = function () {
  this.currentImage && this.ctx.clearRect(this.translateX, this.translateY, this.scale * this.currentImage.width, this.scale * this.currentImage.height)
}
,
  panZoomImage.drawImageAndLens = function () {
  if (this.currentImage) {
    var c = (this.getLensImage(),
             this.getFullImage());
    this.ctx.drawImage(c, 0, 0, this.currentImage.width, this.currentImage.height, this.translateX, this.translateY, this.currentImage.width * this.scale, this.currentImage.height * this.scale),
      1 !== this.lens && 2 !== this.lens || this.drawLens()
  }
}
,
  panZoomImage.clearLens = function () {
  this.currentImage && this.ctx.drawImage(this.getFullImage(), (this.lastX - this.translateX - 50) / this.scale, (this.lastY - this.translateY - 50) / this.scale, 100 / this.scale, 100 / this.scale, this.lastX - 50, this.lastY - 50, 100, 100)
}
,
  panZoomImage.drawLens = function () {
  this.currentImage && 0 !== this.lens && (this.ctx.save(),
                                           this.ctx.beginPath(),
                                           this.ctx.arc(this.lastX, this.lastY, 50, 0, 2 * Math.PI),
                                           this.ctx.clip(),
                                           this.ctx.drawImage(this.getLensImage(), (this.lastX - this.translateX - 50) / this.scale, (this.lastY - this.translateY - 50) / this.scale, 100 / this.scale, 100 / this.scale, this.lastX - 50, this.lastY - 50, 100, 100),
                                           this.ctx.restore())
}
,
  panZoomImage.redraw = function () {
  this.currentImage && (this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height),
                        this.drawImageAndLens())

}
,
  panZoomImage.canvas.addEventListener("mousedown", function (a) {
  //   document.body.style.mozUserSelect = document.body.style.webkitUserSelect = document.body.style.userSelect = "none",
  //     panZoomImage.lastX = a.offsetX || a.pageX - panZoomImage.canvas.offsetLeft,
  //     panZoomImage.lastY = a.offsetY || a.pageY - panZoomImage.canvas.offsetTop,
  //     panZoomImage.dragStart = {
  //     x: panZoomImage.lastX,
  //     y: panZoomImage.lastY
  //   },
  //     panZoomImage.dragged = !1
}, !1),
  panZoomImage.canvas.addEventListener("mousemove", function (a) {
  //   var b = a.offsetX || a.pageX - panZoomImage.canvas.offsetLeft
  //   , c = a.offsetY || a.pageY - panZoomImage.canvas.offsetTop;
  //   panZoomImage.dragged = !0,
  //     panZoomImage.dragStart ? (panZoomImage.clearImage(),
  //                               panZoomImage.translateX += b - panZoomImage.lastX,
  //                                 panZoomImage.translateY += c - panZoomImage.lastY) :
  //     panZoomImage.lastX = b,
  //     panZoomImage.lastY = c,
  //     panZoomImage.dragStart
}, !1),
  panZoomImage.zoom = function (a) {
  //   if (this.currentImage) {
  //     this.clearImage();
  //     var b = this.scale;
  //     this.scale *= Math.pow(1.1, a),
  //       this.translateX += (this.translateX - this.lastX) * (this.scale / b - 1),
  //       this.translateY += (this.translateY - this.lastY) * (this.scale / b - 1),
  //       this.drawImageAndLens()
  //   }
}
,
  panZoomImage.canvas.addEventListener("mouseup", function (a) {
  //   panZoomImage.dragStart = null,
  //     panZoomImage.dragged || panZoomImage.zoom(a.shiftKey ? -1 : 1)
}, !1);
// var handleScroll = function (a) {
//   var b = a.wheelDelta ? a.wheelDelta / 40 : a.detail ? -a.detail : 0;
//   return b && panZoomImage.zoom(b),
//     a.preventDefault() && !1
// };
// panZoomImage.canvas.addEventListener("DOMMouseScroll", handleScroll, !1),
//   panZoomImage.canvas.addEventListener("mousewheel", handleScroll, !1);

function getOrientation(file, callback) {
  var reader = new FileReader();
  reader.onload = function (e) {

    var view = new DataView(e.target.result);
    if (view.getUint16(0, false) != 0xFFD8) {
      return callback(-2);
    }
    var length = view.byteLength, offset = 2;
    while (offset < length) {
      if (view.getUint16(offset + 2, false) <= 8) return callback(-1);
      var marker = view.getUint16(offset, false);
      offset += 2;
      if (marker == 0xFFE1) {
        if (view.getUint32(offset += 2, false) != 0x45786966) {
          return callback(-1);
        }

        var little = view.getUint16(offset += 6, false) == 0x4949;
        offset += view.getUint32(offset + 4, little);
        var tags = view.getUint16(offset, little);
        offset += 2;
        for (var i = 0; i < tags; i++) {
          if (view.getUint16(offset + (i * 12), little) == 0x0112) {
            return callback(view.getUint16(offset + (i * 12) + 8, little));
          }
        }
      }
      else if ((marker & 0xFF00) != 0xFF00) {
        break;
      }
      else {
        offset += view.getUint16(offset, false);
      }
    }
    return callback(-1);
  };
  reader.readAsArrayBuffer(file);
}

function resetOrientation(srcBase64, srcOrientation, callback) {
  console.log("Called 2");
  var img = new Image();	
  img.src = srcBase64;
  img.onload = function() {
    var width = img.width,
        height = img.height,
        canvas = document.createElement('canvas'),
        ctx = canvas.getContext("2d");

    // set proper canvas dimensions before transform & export
    if (4 < srcOrientation && srcOrientation < 9) {
      canvas.width = height;
      canvas.height = width;
    } else {
      canvas.width = width;
      canvas.height = height;
    }

    // transform context before drawing image
    switch (srcOrientation) {
      case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
      case 3: ctx.transform(-1, 0, 0, -1, width, height ); break;
      case 4: ctx.transform(1, 0, 0, -1, 0, height ); break;
      case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
      case 6: ctx.transform(0, 1, -1, 0, height , 0); break;
      case 7: ctx.transform(0, -1, -1, 0, height , width); break;
      case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
      default: break;
    }
    console.log("Called 4");

    // draw image
    ctx.drawImage(img, 0, 0);

    // export base64
    callback(canvas.toDataURL());
  };
}

function IsSafari() {

  var is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
  return is_safari;

}